import Index from "../Components/UserProfile/Index";

export default function UserProfile() {
  return <Index />;
}
